<div class="dialog__info" [class]="cssClass()">
  <p>
    {{ label() }}
  </p>
</div>
